export default {
  data: () => ({
    result_map:{
      pending: {
        text: 'A calcular',
        color: 'blue-grey',
        icon: 'mdi-timeline-clock-outline'
      },
      fully_approved: {
        text: 'Aprovado',
        color: 'tertiary',
        icon: 'mdi-check-decagram-outline'
      },
      approved_with_restrictions: {
        text: 'Com restrições',
        color: 'secondary',
        icon: 'mdi-progress-alert'
      },
      disapproved: {
        text: 'Reprovado',
        color: 'error',
        icon: 'mdi-alert-octagram-outline'
      },
    },
    nonconformity_kind_map:{
      restriction: 'Restrição',
      interdiction: 'Interdição',
    },
  }),
};
